<img
  #img
  [src]="getImgSource()"
  (error)="
    img.src =
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fuser-blank%402x.png?alt=media&token=c06cd4ba-188a-436d-a691-72d469a0e8a5'
  "
/>
